import { UseMutationResult, useMutation } from 'react-query'

export const useDownloadInvoice = (): UseMutationResult<
  Response,
  Error,
  { data: { agency_id: string; path: string } }
> => {
  return useMutation<Response, Error, { data: { agency_id: string; path: string } }>(
    ({ data }: { data: { agency_id: string; path: string } }): Promise<Response> =>
      fetch(`${import.meta.env.VITE_API_URL}/agencies/${data.agency_id}/invoices`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          path: data.path,
        }),
      }),
  )
}
